export default "__VITE_ASSET__kv0dlDka__"